<template>
  <div :class="showFooter ? 'dibuRouter' : 'dibu1'">
    <div class="dibu1-2">
      <div class="nire">
        <p>联系我们</p>
        <div class="konlys">
          <img src="../../assets/image/ic_local.svg" /><span>湖南省长沙市望城区创智岛产业园9-7栋2楼</span>
        </div>
        <div class="konlys">
          <img src="../../assets/image/ic_phone.svg" /><span>0731-88367088</span>
        </div>
        <div class="konlys">
          <img src="../../assets/image/ic_mail.svg" /><span>isoftfactory@163.com</span>
        </div>
        <div class="konlys">
          <img src="../../assets/image/ic_watch.svg" /><span>9:00-12:00 14:00-17:00 周一至周五</span>
        </div>
        <div class="konlys">
          <a style="color: #BDBDBD">友情链接：</a>
          <a href="https://beian.miit.gov.cn/" target="_blank"
            style="cursor: pointer; margin-left: 20px; color: #BDBDBD">虚假网站投诉</a>
        </div>
        <div class="konlys">
          <router-link style="cursor: pointer; color: #BDBDBD" to="/complaint.html">平台投诉中心</router-link>
        </div>
      </div>
      <div class="nire newNire" style="padding-left: 176px">
        <p>关注公众号</p>
        <!-- <div style="margin-bottom: 10px; margin-top: 29px">    </div> -->
        <div class="nire_boy">
          <div class="nire_boy_item">
            <p>获取最新项目信息</p>
            <img src="../../assets/image/IMG_5062.jpg" width="138px" />
            <!-- <p><router-link to="/complaint.html">平台投诉中心</router-link></p> -->
          </div>
          <div class="nire_boy_item" style="margin-left:56px">
            <p>官方抖音号，扫一扫关注</p>
            <img src="../../assets/image/Group_75.png" width="138px" />
            <!-- <p></p> -->
          </div>
        </div>
      </div>
    </div>
    <div class="beian">
      <div class="zhengshu" ref="beianContainer">
      </div>
      <p @click="inkai" style="cursor: pointer;font-family: PingFang-SC-Regular, PingFang-SC;">
        湘ICP备2021015650号-1 © 版权所有：华腾软件产业有限公司
      </p>
    </div>
  </div>
</template>
<script>
import { setToken, removeToken, getToken } from "@/utils/auth";
import { keplerUrl } from "@/api/common";
export default {
  data() {
    return {
      // center:{lng:112.881016,lat:28.297297},
      // zoom:20,
      showFooter: false,
      showF: null,
      kepler: "",
      taorj: "http://taorj.isoftfactory.com/"
    };
  },
  mounted() {
    keplerUrl().then(res => {
      this.kepler = res.keplerAddress;
      this.taorj = res.taoRJAddress;
    });
    this.insertCertificate(); // 组件加载时执行
  },
  created() {
    this.showF = window.location.pathname;
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.name == "acpUserIndex") {
          this.showFooter = true;
        } else {
          this.showFooter = false;
        }
      },
      immediate: true
    }
  },
  methods: {
    insertCertificate() {
      // 1. 创建 `a` 标签
      const link = document.createElement("a");
      link.href =
        "https://xyt.xcc.cn/getpcInfo?sn=1818231871775956992&language=CN&certType=8&url=www.isoftfactory.com";
      link.target = "_blank";

      // 2. 创建 `div` 覆盖 `a` 内容，确保点击范围完整
      const div = document.createElement("div");
      Object.assign(div.style, {
        width: "100%",
        height: "100%",
        position: "absolute",
        top: "0",
        left: "0"
      });

      // 3. 创建 `embed` 插入 SVG 图片
      const embed = document.createElement("embed");
      embed.src = require("@/assets/www.isoftfactory.com.svg"); // Vue 需要 `require`
      embed.width = "200";
      embed.height = "100";
      embed.type = "image/svg+xml";

      // 4. 组装 HTML 结构
      link.appendChild(div);
      link.appendChild(embed);

      // 5. 插入到 `.beian` 容器里
      if (this.$refs.beianContainer) {
        this.$refs.beianContainer.appendChild(link);
      }
    },
    // handler({BMap, map}) {
    //   console.log(BMap, map)
    //   this.center.lng = 112.881016
    //   this.center.lat = 28.297297
    //   this.zoom = 20
    // },
    Tousu() {
      this.$emit("Tousui");
    },
    Tszx() {
      this.$router.replace("/complaint");
    },
    xjts() {
      window.open("https:/www.12377.cn");
    },
    openIndex(lai) {
      if (lai === "1") {
        this.$router.push("/");
      } else if (lai === "2") {
        this.$router.push("/ProjectSquare");
      } else if (lai === "3") {
        this.$router.push("/showRules.html/01/011");
      } else if (lai === "4") {
        this.$router.push("/help");
      } else if (lai === "5") {
        // window.open("http://36.158.225.130:9880/#/index");
        if (getToken()) {
          window.open(
            this.kepler + "workspace/#/plant?token=" + getToken() + "&apltId="
          );
        } else {
          window.open(this.kepler);
        }
        //this.$router.push("/classUtils/classItems");
      } else if (lai === "6") {
        this.$router.push("/AboutUs");
      } else if (lai === "7") {
        if (getToken()) {
          window.open(this.taorj + "?token=" + getToken());
        } else {
          window.open(this.taorj);
        }
      } else if (lai === "8") {
        this.$router.push("/classUtils/classItems");
      }
    },
    inkai() {
      window.open("https://beian.miit.gov.cn/");
    },
    // 链接kpl
    kaipl() {
      window.open(this.kepler); //"http://36.158.225.130:9880/"
    }
  }
};
</script>
<style scoped>
/* 当前页面的最外部div 12-02 */
/* .Box{
    filter:progid:DXImageTransform.Microsoft.BasicImage(graysale=1);
    -webkit-filter: grayscale(100%);
  } */
.newNire div {
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  line-height: 1.4;
}

.newNire img {
  border-radius: 8px;
}

.newNire {
  text-align: left;
  padding-left: 50px;
}

p,
a {
  font-family: PingFang-SC-Regular, PingFang-SC;
}

.beian {
  width: 100%;
  /* height: 44px; */
  background: #000000;
  font-size: 14px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: #f2f2f2;
  line-height: 44px;
}

.zhengshu {
  /* height: 80px; */
  position: relative;
  height: 80px;
}

.dibu1 {
  padding: 0;
  margin: 0;
  width: 100%;
  background: #1c1c1c;
}

.dibuRouter {
  padding: 0;
  margin: 0;
  width: 100%;
  /* height: 46rem; */
  background: #1c1c1c;
}

.dibu1-1 {
  width: 1200px;
  box-sizing: border-box;

  margin: 0px auto;
  padding-top: 64px;
  padding-bottom: 16px;
  border-bottom: 1px solid #4e4e5d;
  text-align: left;
  display: flex;
  justify-content: space-around;
}

.dibu1-1 span {
  color: #e5e5e5;
  /* margin-right: 5.56rem;*/
}

.dibu1-2 {
  width: 1200px;
  box-sizing: border-box;
  /* height: 21.5rem; */
  line-height: 2.5rem;
  margin: 0 auto;
  padding: 4rem 0;

  display: flex;
  justify-content: left;
}

.nire {
  color: #e5e5e5;
  padding-left: 0.625rem;
  width: 40%;
  height: 21.5rem;
  /* border: 1px solid #5FB6D9; */
  text-align: left;
}

.konlys {
  margin: 2.1rem 0;
  color: #c1c1c1;
  line-height: 16px;
}

.konlys span {
  font-family: PingFang-SC-Regular, PingFang-SC;
}

.konlys img {
  width: 18px;
  height: 20px;
  margin-bottom: -6px;
  margin-right: 10px;
}

a {
  text-decoration: none;
  color: #f0f0f0;
}

.router-link-active {
  text-decoraction: none;
  color: #f0f0f0;
}

.footer {
  /* position: relative; */
  height: 175px;
  width: 100%;
  color: #333333;
  background-color: #e5e5e5;
}

.footer .content {
  width: 1130px;
  margin: 0px auto;
  padding: 60px 0;
  display: flex;
  justify-content: space-around;
}

.footItem {
  display: flex;
  align-items: center;
}

.text {
  margin-left: 10px;
}

.nire_boy {
  display: flex;
  align-items: center;
  margin-top: 22px !important;
}

.nire_boy p,
.nire_boy p a {
  font-size: 14px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: #bdbdbd;
  line-height: 25px;
}

.nire_boy_item p {
  font-family: PingFang-SC-Regular, PingFang-SC;
  margin-top: 8px;
  font-size: 16px;
  margin-bottom: 30px;
  color: #c1c1c1;
}
</style>



// WEBPACK FOOTER //
// src/components/footdibu/dibu.vue